import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import './header.css';
import { userRoles } from 'util/appConstants';
import { Images } from 'util/images';
import { getConfig } from 'functions/getConfig';
import { Link } from 'user/components';

const getRedirectUrl = (userRole, isTicketAuth) => {
  if (isTicketAuth) return `${getConfig().REACT_URL}/tickets`;
  if (userRole === 'candidate') return getConfig().REACT_URL;
  return `${getConfig().REDIRECTION_URL}/dashboard`;
};

export default function HeaderCompany() {
  const { userRole, isTicketAuth, user, company } = useSelector((state) => state.auth);

  const [isNotAtsUser, setIsNotAtsUser] = useState(true);
  const [redirectUrl, setRedirectUrl] = useState(getRedirectUrl(userRole, isTicketAuth));

  useEffect(() => {
    setIsNotAtsUser(!!company?.testsOnly);
  }, [company]);

  useEffect(() => {
    setRedirectUrl(getRedirectUrl(userRole, isTicketAuth));
  }, [userRole, isTicketAuth]);

  const getTagText = () => {
    if (company?.limitless) {
      return 'Unlimited';
    }
    let credits = company?.credits ?? 0;
    let numberOfTests = Math.floor(credits / 100);
    let tagText = '';
    if (numberOfTests === 1) {
      tagText = numberOfTests + ' test';
    } else if (numberOfTests >= 1) {
      tagText = numberOfTests + ' tests';
    } else {
      tagText = '0 tests left! Click here to buy more';
    }
    return tagText;
  };

  const getUserDetails = () => {
    return (
      <>
        {userRole !== userRoles.CANDIDATE && company && (
          <div className="testsTag">
            <Link to="/payments">{getTagText()}</Link>
          </div>
        )}
        <a href={redirectUrl}>
          <div className="header-userDetails-container row mr-2">
            <div className="userDetailsContainer">
              <h4 className="userName">{user.name || user.coderCommunityProfile?.name}</h4>
              {company?.name && <h6 className="companyName">{company.name}</h6>}
            </div>
            {typeof user.avatar !== 'string' || user.avatar?.search('/images') === 0 ? (
              <img src={Images.defaultAvatar} alt="profile pic" className="profileImage" />
            ) : (
              <img src={user.avatar} alt="profile pic" className="profileImage" />
            )}
          </div>
        </a>
      </>
    );
  };

  const getHeaderLinks = () => {
    return (
      <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
        {(!userRole || userRole === userRoles.CANDIDATE || isTicketAuth) && (
          <>
            <li className="mr-3">
              <Link className="nav-link headerLink" to="/challenges">
                Challenges
              </Link>
            </li>
            <li className="mr-3">
              <Link className="nav-link headerLink" to="/exercises">
                Exercises
              </Link>
            </li>
            {/* <li className="mr-3">
              <Link className="nav-link headerLink" to="/freecode">
                Freecode
              </Link>
            </li> */}
            <li className="mr-3">
              <Link className="nav-link headerLink" to="/courses">
                Courses
              </Link>
            </li>
          </>
        )}
        {userRole && userRole !== userRoles.CANDIDATE && !isNotAtsUser && !isTicketAuth && (
          <li className="mr-3">
            <a href={getConfig().REDIRECTION_MANAGE_JOBS_URL} className="nav-link headerLink">
              Jobs
            </a>
          </li>
        )}
        {userRole && userRole !== userRoles.CANDIDATE && !isTicketAuth && (
          <li className="mr-3">
            <a href={getConfig().REDIRECTION_TEST_URL} className="nav-link headerLink">
              Tests
            </a>
          </li>
        )}
        {userRole && userRole !== userRoles.CANDIDATE && isNotAtsUser && !isTicketAuth && (
          <li className="mr-3">
            <a
              href={`${getConfig().REACT_URL}/send-test`}
              className={`nav-link headerLink ${window.location.pathname === '/send-test' && 'headerLinkActive'}`}
            >
              Send Test
            </a>
          </li>
        )}
        {userRole && userRole !== userRoles.CANDIDATE && !isNotAtsUser && !isTicketAuth && (
          <li className="mr-3">
            <a href={getConfig().REDIRECTION_CANDIDATES_URL} className="nav-link headerLink">
              Candidates
            </a>
          </li>
        )}
        {userRole && userRole !== userRoles.CANDIDATE && !isNotAtsUser && !isTicketAuth && (
          <li className="mr-3">
            <a href={getConfig().REDIRECTION_MESSAGES_URL} className="nav-link headerLink">
              Messages
            </a>
          </li>
        )}
      </ul>
    );
  };

  return (
    <nav className="navbar navbar-dark navbar-expand-lg">
      <a href={redirectUrl}>
        <img src={Images.logo} alt="FS" className="pull-xs-left main-logo aos-init aos-animate fsLogo" />
      </a>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo02"
        aria-controls="navbarTogglerDemo02"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
        {getHeaderLinks()}
        {userRole && <div className="form-inline my-2 ml-3 my-lg-0">{getUserDetails()}</div>}
      </div>
    </nav>
  );
}
